<template>
  <a-tabs v-model:activeKey="activeKey">


    <a-tab-pane key="1" tab="基本信息">
      <tableItem :tableStatus="0"
        :tableObjTitle="store.roles.includes('carEnterprise') ? informationTitle2 : informationTitle"
        :tableObjData="informationObj" style="margin-top:16px">
        <template v-slot:headTitle>
          基本信息
        </template>
      </tableItem>


    </a-tab-pane>

    <a-tab-pane key="2" tab="关联车辆">
      <div class="box ">
        <div class="title" style="width:870px;margin:16px auto 24px auto;">关联车辆</div>
        <tableItem :tableStatus="1" :tableArrayTitle="firstTitle" :tableArrayData="firstData" :tableStyle="tableStyle"
          class="table_center"></tableItem>
      </div>

    </a-tab-pane>

    <a-tab-pane key="3" tab="测试记录">
      <div class="box">
        <div class="title">测试记录</div>
        <a-table :columns="columns" :row-key="(record) => record.id" :data-source="dataSource" size="middle"
          class="mt23" :pagination="false" :scroll="{ y: 'auto', }" v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
          <template #bodyCell="{ column, record, index }">

            <template v-if="column.key === 'ranking'">
              {{ index + 1 }}
            </template>
            <template v-if="column.key === 'startTime'">
              {{ record.startTime }}至{{ record.endTime }}
            </template>
            <template v-if="column.key === 'status'">
              {{ record.status === 0 ? '待测试' : record.status === 1 ? '测试中' : record.status === 2 ? '已结束' : '' }}
            </template>
            <template v-if="column.key === 'driverPersonName'">
              驾驶员: {{ record.driverPersonName }}
              安全员:{{ record.securityPersonName }}
            </template>
            <template v-if="column.key === 'reservation'">
              {{ record.reservation === 0 ? '否' : record.reservation === 1 ? '是' : '' }}
            </template>
            <template v-if="column.key === 'endDetailStatus'">
              {{ record.endDetailStatus === 1 ? '已测试' : record.reservation === 2 ? '超时未测试' : record.reservation ===
                3 ? '超时未审批' : record.reservation === 4 ? '审核不通过' : '' }}
            </template>
            <template v-if="column.key === 'testType'">
              {{ getSingleTypeValue(appStore.SysDictVOList, dataType + 'category' +
                record.testType) }}
            </template>

            <template v-else-if="column.key === 'action'">
              <span>
                <a class="" @click="jumpDetail(record, 1)">查看详情</a>
                <a class="ml10">测试报告</a>
              </span>
            </template>
          </template>
        </a-table>
      </div>
    </a-tab-pane>
    <a-tab-pane key="4" tab="事故记录">
      <div class="box">
        <div class="title">事故记录</div>
        <a-table :columns="columns2" :row-key="(record) => record.id" :data-source="dataSource2" size="middle"
          class="mt23" :pagination="false" :scroll="{ y: 'auto', }" v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
          <template #bodyCell="{ column, record, index }">

            <template v-if="column.key === 'ranking'">
              {{ index + 1 }}
            </template>

            <template v-if="column.key === 'testType'">
              {{ getSingleTypeValue(appStore.SysDictVOList, dataType + 'category' +
                record.testType) }}
            </template>
            <template v-if="column.key === 'status'">
              <a-switch v-model:checked="record.status" checked-children="启用" un-checked-children="禁用" />
            </template>
            <template v-if="column.key === 'accidentTime'">
              {{ moment(record.accidentTime).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
            <template v-else-if="column.key === 'action'">
              <span>
                <a class="ml10" @click="jumpDetail(record, 2)">查看详情</a>
              </span>
            </template>
          </template>
        </a-table>
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script setup>
import { ref, defineProps, watch, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import tableItem from '@/components/tableItem/index.vue'
import moment from 'moment';
import useUserStore from '@/store/modules/user'
import { getSingleTypeValue } from '@/utils/matchDic.js'
import useAppStore from '@/store/modules/app'

const router = useRouter()
const route = useRoute()

const appStore = useAppStore()
const dataType = 'testType'


const props = defineProps({
  informationObj: {
    type: Object,
    default: () => {
      return {}
    }
  },
  firstData: {
    type: Array,
    default: () => {
      return []
    }
  },
  dataSource: {
    type: Array,
    default: () => {
      return []
    }
  },
  dataSource2: {
    type: Array,
    default: () => {
      return []
    }
  }
})

watch(
  () => props.informationObj,
  (record) => {
    console.log(record);
    if (record) {
      let data1 = record.personType ? record.personType.split(',')[0] === 'driver' ? '驾驶员' : record.personType.split(',')[0]
        === 'security' ? '安全员' : '' : ''
      let data2 = record.personType ? record.personType.split(',')[1] ? record.personType.split(',')[1] ===
        'driver' ? '驾驶员' : record.personType.split(',')[1]
          === 'security' ? '安全员' : '' : '' : ''
      console.log(data1, data2);
      record.personType = data2 ? data1 + '/' + data2 : data1
      record.gender = record.gender === 0 ? '女' : '男'
      let data3 = record.certificateType === 'idCard' ? '身份证' : ''
      record.certificateNum = record.certificateNum ? data3 + '/' + record.certificateNum : record.certificateNum
    }
  },
)

const activeKey = ref('1');
const store = useUserStore()

const columns = [
  {
    title: "序号",
    key: "ranking",
  },
  {
    title: "申请时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "测试区域",
    dataIndex: "testZone",
    key: "testZone",
    // width: 100,
  },
  {
    title: "测试类型",
    key: "testType",
    // width: 100,
  },
  {
    title: "测试人员",
    key: "driverPersonName",
  },
  {
    title: "测试道路",
    key: "testRoads",
    dataIndex: "testRoads",
    // width: 240,
  },
  {
    title: "是否需要预约",
    key: "reservation",
  },
  {
    title: "测试时间",
    key: "startTime",
    // width: 180,
  },
  {
    title: "状态",
    key: "status",
  },
  {
    title: "结果",
    key: "endDetailStatus",
  },
  {
    title: "操作",
    key: "action",
    width: 200
  },
];


const columns2 = [
  {
    title: "序号",
    key: "ranking",
  },
  {
    title: "发生时间",
    // dataIndex: "accidentTime",
    key: "accidentTime",
  },
  {
    title: "测试类型",
    key: "testType",
    // width: 100,
  },
  {
    title: "测试区域",
    key: "testZone",
    dataIndex: "testZone",
    // width: 80,
  },
  {
    title: "测试道路",
    key: "testRoads",
    dataIndex: "testRoads",
  },
  {
    title: "操作",
    key: "action",
    width: 200
  },
];

// 基本信息
const informationTitle = ref([
  { tableLeft: '企业名称', tableRight: '类型', dataSource: 'deptName', innerDataSource: 'personType' },
  { tableLeft: '性别', tableRight: '证件类型及证件号', dataSource: 'gender', innerDataSource: 'certificateNum' },
  { tableLeft: '出生年月', tableRight: '培训时间', dataSource: 'birthDate', innerDataSource: 'trainDate' },
  { tableLeft: '电话号码', tableRight: '驾驶证号', dataSource: 'phoneNum', innerDataSource: 'driverNum' },
])

const informationTitle2 = ref([
  { tableLeft: '性别', tableRight: '类型', dataSource: 'gender', innerDataSource: 'personType' },
  { tableLeft: '出生年月', tableRight: '证件类型及证件号', dataSource: 'birthDate', innerDataSource: 'certificateNum' },
  { tableLeft: '电话号码', tableRight: '培训时间', dataSource: 'phoneNum', innerDataSource: 'trainDate' },
  { tableLeft: '驾驶证号', tableRight: '', dataSource: 'driverNum', innerDataSource: '' },
])

// const informationObj = ref({
//   companyName: 'XXX公司',
//   type: "驾驶员/安全员",
//   gender: "男",
//   idNumber: '身份证，420XXXXXXXXXXXX',
//   birth: "1990-02",
//   timeLimit: '2022-4-29',
//   phone: "15172382XXXX91",
//   driverNumber: '29383837373732',
// })

// 关联车辆
const tableStyle = ref({
  screenHeight: 0,
  isStyle: true,
  personnel: true
})
const firstTitle = ref([
  { title: '车辆编码', dataSource: 'index' },
  { title: '测试牌照', dataSource: 'testCarNum' },
  { title: '车架号', dataSource: 'frameNum' },
])

// const firstData = ref([
//   { vehicleNumber: '29283733', testingLicence: '甘A 39383测', vin: 'LH88272727227' },
//   { vehicleNumber: '29283733', testingLicence: '甘A 39383测', vin: 'LH88272727227' },
//   { vehicleNumber: '29283733', testingLicence: '甘A 39383测', vin: 'LH88272727227' },
// ])

// let dataSource = ref([]);

// let dataSource2 = ref([]);

const jumpDetail = (record, type) => {
  console.log(record);

  if (type === 1) {
    router.push({
      path: "/testManage/taskDetail",
      query: {
        activeKey: '0',
        type: '0',//  0 查看详情模式  ，1编辑模式
        from: "0",  //来源 0 testManage/task  ，1  testManage/reservation
        id: record.id,
      }
    });
  } else {
    router.push({
      path: "/reportManage/accident",
      query: {
        id: record.id,
      }
    });
  }
}

onMounted(() => {
  tableStyle.value.screenHeight = window.innerHeight
  console.log(tableStyle.value.screenHeight,);
  window.onresize = () => {
    return (() => {
      tableStyle.value.screenHeight = window.innerHeight
    })()
  }
})


</script>


<style lang="less" scoped>
.box {
  width: 80%;
  margin: 0 auto;

  a {
    color: #1E8EF2;
  }
}

.title {
  position: relative;
  font-size: 14px;
  font-weight: 600;
  color: #1D2129;
  line-height: 16px;
  padding-left: 10px;
  margin: 16px 0 24px 0;

  &::before {
    content: "";
    display: inline-block;
    height: 100%;
    width: 3px;
    background: #1E8EF2;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>